export type ReceiptComplaintType = typeof receiptComplaintTypes[number]

export const COMPLAINT_INVOICE_TYPE = 'FC'
export const COMPLAINT_REMITTANCE_TYPE = 'RT'
export const COMPLAINT_ORDER_TYPE = 'PD'
export const COMPLAINT_OTHERSRECEIPT_TYPE = 'OTR'

export const receiptComplaintTypes = [COMPLAINT_INVOICE_TYPE, COMPLAINT_REMITTANCE_TYPE, COMPLAINT_ORDER_TYPE, COMPLAINT_OTHERSRECEIPT_TYPE]

export const receiptComplaintTypeToDescription = (type: ReceiptComplaintType): string => {
  switch (type) {
    case COMPLAINT_INVOICE_TYPE: return "invoice"
    case COMPLAINT_REMITTANCE_TYPE: return "remittance"
    case COMPLAINT_ORDER_TYPE: return "order"
    case COMPLAINT_OTHERSRECEIPT_TYPE: return "other"
  }
  return "not"
}

export type ReceiptType = typeof receiptTypes[number]

//export const receiptTypes = ['CA', 'CB', 'CE', 'CP', 'DA', 'DB', 'DE', 'EA', 'EB', 'FA', 'FB', 'FE', 'HR', 'PD', 'RC', 'RX']

export const RECEIPT_INVOICE_TYPE = 'F'
export const RECEIPT_CREDIT_TYPE = 'C'
export const RECEIPT_DEBIT_TYPE = 'D'
export const RECEIPT_OTHER_TYPE = 'O'
export const RECEIPT_BOUNCED_TYPE = 'R'

export const receiptLegalTypes = [RECEIPT_INVOICE_TYPE, RECEIPT_CREDIT_TYPE, RECEIPT_DEBIT_TYPE]
export const receiptTypes = [...receiptLegalTypes, RECEIPT_OTHER_TYPE]
export const receiptTypesWithBounced = [...receiptLegalTypes, RECEIPT_BOUNCED_TYPE]

export const receiptTypeToDescription = (type: ReceiptType): string => {
  switch (type) {
    case RECEIPT_INVOICE_TYPE: return 'Invoices'
    case RECEIPT_CREDIT_TYPE: return 'Credits'
    case RECEIPT_DEBIT_TYPE: return 'Debits'
    case RECEIPT_OTHER_TYPE: return 'Others'
    case RECEIPT_BOUNCED_TYPE: return 'Bounced'
    
  }
  return "not"
}
